export default {
  balanceAndgoldenPocket: 'Số dư / goldenPocket',
  enableGoldenPocket: 'Mở GoldenPocket',
  GoldenPocketStatus: 'Có nên kích hoạt trạng thái GoldenPocket không',
  goldenPocket: 'GoldenPocket',
  goldenPocketTotalBlance: 'GoldenPocket Tổng số dư',
  GoldenPocketClose: 'Đã đóng',
  GoldenPocketOpen: 'Đã mở',
  NotGoldenPocket: 'Không có sẵn',
  createMomoOrder: 'Tạo lệnh rút MoMo',
  createZaloOrder: 'Tạo lệnh rút Zalo',
  createVIETTELOrder: 'Tạo lệnh rút  VIETTEL',
  home: 'Trang chủ',
  login: 'Đăng nhập',
  register: 'Đăng ký ',
  logout: 'Đăng xuất',
  confirmLogout: 'Đăng xuất nhé？',
  username: 'Tên tài khoản',
  password: 'Mật khẩu',
  enterPassword: 'Xin vui lòng nhập mật khẩu',
  submit: 'Tạo mới',
  search: 'Tìm kiếm',
  option: 'Thao tác',
  new: 'Tạo mới',
  edit: 'Biên tập',
  cancelEdit: 'Đã khôi phục cài đặt gốc',
  delete: 'Xóa',
  warning: 'Cảnh báo',
  week: 'Tuần gần nhất',
  mount1: 'Tháng gần nhất',
  mount3: '3 tháng gần nhất',
  to: 'đến',
  startDate: 'Ngày bắt đầu',
  endDate: 'Ngày kết thúc',
  confirmDelete: 'Bạn chắc chắn xóa mục này',
  yes: 'Xác nhận',
  cancel: 'Thoát',
  success: 'Thành công',
  fail: 'Thất bại',
  active: 'Đã kích hoạt',
  normal: 'Bình thường',
  expired: 'Đã hết hạn',
  unActive: 'Đang đóng',
  init: 'Tạo mới',
  open: 'Mở',
  close: 'Đóng',
  serial: 'Mã thiết bị',
  enterSerial: 'Nhập mã thiết bị',
  amount: 'Số tiền',
  balance: 'Số dư',
  desc: 'Miêu tả',
  remark: 'Nhận xét',
  name: 'Tên',
  status: 'Trạng thái',
  createDate: 'Thời gian tạo',
  createBy: 'Người thao tác',
  doActive: 'Kích hoạt',
  cancelActive: 'Hủy kích hoạt',
  online: 'Online',
  outline: 'Offline',
  faceline: 'Cần xác thực CCCD',
  locked: 'Khóa',
  resend: 'Gửi lại',
  updateDate: 'Thời gian cập nhật',
  updateBy: 'Người cập nhật',
  reset: 'Cài đặt lại',
  choose: 'Xin chọn',
  opened: 'Kích hoạt thành công',
  closed: 'Tắt thành công',
  pullBalance: 'THĂNG BẰNG',
  supplier: 'nhà điều hành',
  placeholder: 'vui lòng nhập',
  bankInfo: 'Thông tin tài khoản ngân hàng',
  trueName: 'Tên thật tài khoản',
  inBalance: 'Tiền gửi',
  outBalance: 'Pha Chế',
  payment: 'Trả tiền thay mặt cho',
  cancelPayment: 'Hủy thanh toán',
  openPayment: 'Kích hoạt thanh toán',
  BindingSession: 'ràng buộc Session',
  Binding: 'ràng buộc',

  homePage: {
    globalLang: 'Ngôn ngữ quốc tế',
    fontSize: 'size chữ',
    sizeDefault: 'Mặc định',
    sizeMedium: 'Trung bình',
    sizeSmall: 'Nhỏ',
    sizeMini: 'Nhỏ nhất'
  },
  changePwd: {
    title: 'Đổi mật khẩu',
    confirmPwd: 'Xác nhận mật khẩu',
    pwdPlaceholder: 'Nhập mật khẩu',
    pwdPlaceholderAgain: 'Nhập lại mật khẩu'
  },
  momo: {
    title: 'Tài khoản Momo',
    list: {
      BatchGoldenPocket: 'Mở hàng loạt GoldenPocket',
      title: ' Danh sách tài khoản',
      phoneNo: 'Số điện thoại',
      receive: 'Trạng thái nhận thanh toán',
      noEdit: 'Số điện thoại đã được phục hồi nguyên bản',
      initSuccess: 'Khởi tạo thành công, muốn đăng ký thiết bị?',
      registerSuccess: 'Đăng ký thành công，có muốn gửi OTP đến thiết bị?',
      createSuccess: 'Tạo mới thiết bị thành công, có muốn khởi tạo thiết bị?',
      withdrawalLimit: 'Giới hạn rút tiền',
      fixedWithdrawalLimit: 'Giới hạn rút tiền cố định',
      autoReceive: 'Thanh toán tự động',
      todayReceive: 'Tiền nhận trong ngày',
      monthReceive: 'Tháng này nhận',
      dayWithdrawnAmount: 'Số tiền rút trong ngày',
      withdrawnAmount: 'Số tiền rút hàng tháng',
      withdrawalTotalFee: 'Đã rút tiền phí xử lý',
      step1: 'Thông tin cơ bản',
      step2: 'Khởi tạo thiết bị',
      step3: 'Đăng ký thiết bị',
      step4: 'Hoàn thành',
      otpTip: 'Nhập 4 số OTP',
      vtpotpTip: 'Nhập 4 số OTP',
      zaloOtpTip: 'Nhập 6 số OTP',
      googleTip: 'Nhập 6 số Google',
      node: "* Xin chú ý! Tắt tất cả các ứng dụng trên thiết bị (Để tất cả thiết bị ở chế độ nền). Sau khi nhấp vào 'Tạo mới', hãy vào lại ứng dụng để chuẩn bị kết nối.",
      inline: 'Đang online?',
      activeTip: 'Bạn có chắc chắn hủy kích hoạt không?',
      unActiveTip: 'Bạn có chắc chắn để kích hoạt không?',
      activeSuccess: 'Kích hoạt thành công',
      unActiveSuccess: 'Đã hủy kích hoạt',
      openReceiveTip: 'Xác nhận tự động nhận chuyển khoản?',
      closeReceiveTip: 'Xác nhận đóng tự động nhận chuyển khoản?',
      closeTip: 'Bạn có chắc chắn tắt thanh toán tự động không?',
      openTip: 'Bạn có chắc chắn bật thanh toán tự động không?',
      paymentSuccess: 'Thanh toán tự động đã được bật',
      payment: 'Trả tiền thay mặt cho',
      session: 'Nhập OTP',
      ConfirmCloseTip: 'Bạn có chắc chắn muốn đóng không?',
      ConfirmOpenTip: 'Bạn có chắc chắn muốn bật nó không?'
    },
    onlineList: {
      title: 'Danh sách đã kích hoạt'
    }
  },
  transaction: {
    title: 'Giao dịch Momo',
    createOrder: {
      title: 'Tạo đơn rút tiền',
      tkMomoAccount: 'Tài khoản rút',
      toMomoAccount: 'Tài khoản nhập',
      tkMomoTip: 'Xin chọn 1 tài khoản rút tiền',
      toMomoTip: 'Xin chọn 1 tài khoản nhận tiền',
      type: 'Hình thức rút tiền',
      typeTip: 'Xin chọn 1 hình thức rút tiền',
      bank: 'Chọn 1 tài khoản ngân hàng',
      bankTip: '请选择一个银行',
      tip: 'Rút tiền đến tài khoản',
      withdrawAmount: 'Số tiền rút',
      amountTip: 'Xin nhập số tiền rút',
      amount50w: 'Số tiền chuyển ra không được dưới 50k vnd',
      amount1w: 'Số tiền chuyển ra không được dưới 10k vnd',
      amount100: 'Số tiền chuyển khoản không được dưới 100k vnd',
      node: '* Xin kiểm tra kỹ thông tin trước khi gửi',
      cancelTrans: 'Bạn đã hủy yêu cầu rút tiền',
      transactionNo: 'Số giao dịch',
      transactionContent: 'Biên nhận tin nhắn',
      GoldenPocketOpenAmount: 'Số tiền chuyển khoản GoldenPocket không được nhỏ hơn 2000',
      maxWithdrawal: 'Số tiền rút tối đa',
      calculationFormula: 'Công thức tính toán'
    },
    receive: {
      title: 'LS khoản nhận',
      date: 'Thời gian',
      gdCode: 'Biên lai',
      receiveAccount: 'Tài khoản nhận tiền',
      depositAccount: 'Tài khoản rút tiền',
      receiveTime: 'Thời gian nhận',
      scanTime: 'Thời gian quét mã'
    },
    redpack: {
      openTime: 'Thời gian mở cửa'
    },
    withdrawal: {
      title: 'LS Rút tiền',
      amountTotal: 'Tổng(Số tiền)',
      feeTotal: 'Tổng(Phí thu)',
      date: 'Thời gian',
      gdCode: 'Biên lai',
      depositAccount: 'Tài khoản rút tiền',
      receiveAccount: 'Tài khoản nhận tiền',
      tkName: 'Tên tài khoản ngân hàng',
      cost: 'Phí chuyển khoản',
      total: 'Tổng tiền',
      perAmount: 'Số dư trước chuyển',
      proAmount: 'Số dư sau chuyển',
      type: 'Hình thức',
      author: 'Người thao tác',
      optionTime: 'Thời gian thao tác',
      systemNo: 'Mã đơn hệ thống'
    }
  },
  bankManage: {
    title: 'Momo Ngân hàng',
    addNew: {
      title: 'Thêm thẻ ngân hàng',
      accountNoTip: 'XIn nhập chính xác số tài khoản',
      bank: 'Ngân hàng',
      bankTip: 'Xin chọn ngân hàng',
      bankName: 'Tên ngân hàng',
      bankNameTip: 'Tên ngân hàng không được trống',
      bankNameSortTip: '(Danh mục) tên ngân hàng không được trống',
      bankCodeTip: 'Số thẻ ngân hàng không được trống',
      node: '* Xin check kỹ thông tin trước khi ấn xác nhận',
      tkMomoTip: 'Xin nhập tài khoản Momo',
      tkVtpTip: 'Xin nhập tài khoản VTP',
      bankNumber: 'Số thẻ ngân hàng',
      bankNameSort: 'Tên ngân hàng (danh sách)',
      bankCode: 'Mã ngân hàng',
      tkNameTip: 'Tên ngân hàng không được trống'
    },
    list: {
      title: 'Danh sách thẻ ngân hàng',
      tkMomo: 'Số điện thoại momo',
      accountNo: 'Số tài khoản',
      bankName: 'Tên ngân hàng'
    }
  },
  administrator: {
    title: 'Quản trị viên',
    addNew: {
      title: 'Tạo thêm tài khoản Quản trị',
      account: 'Tên đăng nhập',
      password: 'Mật khẩu',
      confirmPwd: 'Xác nhận mật khẩu',
      group: 'Chức vụ',
      selectGroup: 'Chọn chức vụ',
      nameTip: 'Tên tài khoản không được trống',
      accountTip: 'ID đăng nhập không được trống',
      phoneTip: 'Số điện thoại không được trống',
      passwordTip: 'Mật khẩu không được trống',
      configPwdTip: 'Xin nhập lại mật khẩu',
      groupTip: 'Xin chọn chức vụ'
    },
    list: {
      title: 'Danh sách quản trị viên',
      lastLoginTime: 'Lần cuối đăng nhập'
    },
    ip: {
      title: 'Quản lý IP',
      ipTip: 'Xin nhập địa chỉ IP',
      usernameTip: 'Xin nhập tài khoản quản trị'
    },
    logs: {
      title: 'Nhật ký lỗi tài khoản',
      serialNo: 'số seri',
      serialNumber: 'Số thiết bị',
      errorMsg: 'Thông báo lỗi'
    }
  },
  roleManager: {
    title: 'Quản lý chức vụ',
    roleName: 'Tên chức vụ',
    role: {
      title: 'Tạo mới chức vụ',
      roleNameTip: 'Xin chọn tên chức vụ',
      setting: 'Cài đặt quyền',
      reLogin: 'Sửa đổi thành công, vui lòng đăng nhập lại'
    },
    roleList: {
      title: 'Danh sách chức vụ'
    },
    permission: {
      title: 'Quản lý quyền hạn'
    }
  },
  transactionTypes: {
    1: 'Chuyển khoản nội bộ',
    2: 'Chuyển khoản đến tài khoản ngoài',
    3: 'Chuyển đến tài khoản đã liên kết',
    4: 'Chuyển khoản thanh toán',
    7: 'GoldenPocket',
    72: 'GoldenPocketRelated',
    73: 'GoldenPocketInternal'
  },
  zalo: {
    list: {
      title: 'Tài khoản Zalo'
    },
    trans: {
      title: 'Giao dịch Zalo'
    },
    bank: {
      title: 'Zalo Ngân hàng',
      phone: 'Số điện thoại Zalo',
      account: 'Số điện thoại',
      tkZaloTip: 'Xin nhập tài khoản Zalo'
    }
  },
  vtp: {
    list: {
      title: 'Tài khoản VTP'
    },
    trans: {
      title: 'Giao dịch VTP'
    },
    bank: {
      title: 'VTP Ngân hàng',
      phone: 'Số điện thoại',
      account: 'Số điện thoại',
      tkMomoTip: 'Xin nhập tài khoản VTP'
    }
  },
  momoQr: {
    list: {
      title: 'Tài khoản MOMOQR'
    },
    trans: {
      title: 'Giao dịch MOMOQR'
    },
    bank: {
      title: 'MOMOQR Ngân hàng',
      phone: 'Số điện thoại',
      account: 'Số điện thoại',
      tkMomoTip: 'Xin nhập tài khoản MOMOQR'
    }
  },
  waiting: 'Vui lòng đợi, đang tải xuống. . . .',
  up: 'Thứ tự tăng dần',
  down: 'Thứ tự giảm dần',
  disActive: 'đông cứng',
  sortField: 'Trường sắp xếp',
  limitPlaceHolder: 'Vui lòng nhập giới hạn rút tiền',
  needInput: 'Vui lòng nhập dữ liệu hợp lệ',
  abRecords: {
    title: 'Hồ sơ ngoại lệ'
  },
  lastAccept: 'Thời gian thanh toán cuối cùng',
  sumBalance: 'Tổng số dư',
  version: 'Số phiên bản',
  activatTime: 'Thời gian kích hoạt cuối cùng',
  paymentTime: 'Thời gian thanh toán',
  orderNo: 'Số đơn hàng',
  paymentAccount: 'Tài khoản thanh toán',
  paymentAccountType: 'Loại tài khoản thanh toán',
  transId: 'Mã giao dịch',
  paymentStatus: 'Trạng thái thanh toán',
  paymentRemark: 'Ghi chú thanh toán',
  export: 'Xuất',
  import: 'Nhập',
  downloadTemplate: 'Tải mẫu',
  paymentSupplier: 'Nhà cung cấp thanh toán',
  paymentAmount: 'Số tiền thanh toán',
  DateCreated: 'Thời gian tạo',
  creator: 'Người tạo',
  DateModified: 'Thời gian chỉnh sửa',
  modifier: 'Người chỉnh sửa',
  Upload: 'Tải lên',
  close: 'Đóng',
  confirm: 'Xác nhận',
  state1: 'Đang chờ thanh toán',
  state2: 'Thanh toán thành công',
  state3: 'Đã thanh toán',
  state4: 'Thanh toán thất bại',
  waiting: 'Đang chờ...',
  downLoad: {
    a1: 'Vui lòng tải xuống tệp mẫu trước',
    a2: 'Vui lòng tải lên tệp mẫu',
    selectfile: 'Chọn tệp',
    ImportSuccess: 'Nhập thành công',
    Importfailed: 'Nhập thất bại'
  },
  utilityStatus: 'Trạng thái hóa đơn điện nước',
  WalletBalance: 'Số dư ví',
  开启: 'Mở',
  关闭: 'Đóng',
  开启提示: 'Bạn có chắc chắn muốn bật hàng loạt không?',
  关闭提示: 'Bạn có chắc chắn muốn tắt hàng loạt không?',
  开启成功: 'Mở thành công',
  关闭成功: 'Đóng thành công'
};



// WEBPACK FOOTER //
// ./src/i18n/lang/vi/common.js